export default __webpack_public_path__ + "static/media/usps-icon.5e2e47ef.svg";